const Trash = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M4.35938 6.54204H19.6416" stroke="currentColor" strokeWidth="1.5" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.6378 4.35886H10.3631C9.76021 4.35886 9.27148 4.84758 9.27148 5.45045V6.54204H14.7294V5.45045C14.7294 4.84758 14.2407 4.35886 13.6378 4.35886Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path d="M10.3633 15.8206V10.3626" stroke="currentColor" strokeWidth="1.5" />
    <path d="M13.6387 15.8206V10.3626" stroke="currentColor" strokeWidth="1.5" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.9957 18.6398C16.9487 19.2058 16.4757 19.6412 15.9077 19.6411H8.09268C7.52476 19.6412 7.05167 19.2058 7.00472 18.6398L5.99609 6.54204H18.0036L16.9957 18.6398Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
)

export default Trash
